import CakeIcon from '@mui/icons-material/Cake';
import CircleIcon from '@mui/icons-material/Circle';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import RealEstateAgentRoundedIcon from '@mui/icons-material/RealEstateAgentRounded';
import SavingsRoundedIcon from '@mui/icons-material/SavingsRounded';
import PriceCheckRoundedIcon from '@mui/icons-material/PriceCheckRounded';
import PercentIcon from '@mui/icons-material/Percent';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Filter5Icon from '@mui/icons-material/Filter5';
import SmsIcon from '@mui/icons-material/Sms';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ContactsIcon from '@mui/icons-material/Contacts';
import PermContactCalendarRoundedIcon from '@mui/icons-material/PermContactCalendarRounded';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import TrackChangesRoundedIcon from '@mui/icons-material/TrackChangesRounded';
import WavingHandRoundedIcon from '@mui/icons-material/WavingHandRounded';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';
import ManageHistoryRoundedIcon from '@mui/icons-material/ManageHistoryRounded';
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import AttributionRoundedIcon from '@mui/icons-material/AttributionRounded';
import FactoryRoundedIcon from '@mui/icons-material/FactoryRounded';
import PersonSearchRoundedIcon from '@mui/icons-material/PersonSearchRounded';
import AddLinkRoundedIcon from '@mui/icons-material/AddLinkRounded';
import ConnectWithoutContactRoundedIcon from '@mui/icons-material/ConnectWithoutContactRounded';
import CallMadeRoundedIcon from '@mui/icons-material/CallMadeRounded';
import CallReceivedRoundedIcon from '@mui/icons-material/CallReceivedRounded';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import ViewKanbanRoundedIcon from '@mui/icons-material/ViewKanbanRounded';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import StairsRoundedIcon from '@mui/icons-material/StairsRounded';
import AlarmOnRoundedIcon from '@mui/icons-material/AlarmOnRounded';
import FreeCancellationRoundedIcon from '@mui/icons-material/FreeCancellationRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import SsidChartRoundedIcon from '@mui/icons-material/SsidChartRounded';
import TroubleshootRoundedIcon from '@mui/icons-material/TroubleshootRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import AltRouteRoundedIcon from '@mui/icons-material/AltRouteRounded';
import ChairOutlinedIcon from '@mui/icons-material/ChairOutlined';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import CottageOutlinedIcon from '@mui/icons-material/CottageOutlined';
import FilterAltOffRoundedIcon from '@mui/icons-material/FilterAltOffRounded';
import PhoneDisabledRoundedIcon from '@mui/icons-material/PhoneDisabledRounded';
import DirectionsCarFilledRoundedIcon from '@mui/icons-material/DirectionsCarFilledRounded';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import WidgetsRoundedIcon from '@mui/icons-material/WidgetsRounded';
import PersonOffRoundedIcon from '@mui/icons-material/PersonOffRounded';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';

//icons linked to sections/routes
export const ICONS = {
  PRIORITIES: AlarmOnRoundedIcon,
  REDEMPTION: EmojiEventsRoundedIcon,
  ROLLINGREDEMPTIONREPORT: SsidChartRoundedIcon,
  REDEMPTIONREPORT: TroubleshootRoundedIcon,
  APPOINTMENTSREPORT: FreeCancellationRoundedIcon,
  FUNNELREPORT: FilterListRoundedIcon,
  KANBAN: ViewKanbanRoundedIcon,
  REPORT: QueryStatsRoundedIcon,
  WAVEACTIVITIESREPORT: DashboardRoundedIcon,
  OUTBOUNDCALLSANALYSIS: CallMadeRoundedIcon,
  INBOUNDCALLSANALYSIS: CallReceivedRoundedIcon,
  CUSTOMERS: ContactsIcon,
  LEADS_MANAGEMENT: ConnectWithoutContactRoundedIcon,
  LEADS: PersonSearchRoundedIcon,
  LEAD_ORIGINS: AddLinkRoundedIcon,
  BIRTHDAYS: CakeIcon,
  LIGHT: StarIcon,
  CORPORATE: Filter5Icon,
  PREMIUMBANK: AccountBalanceIcon,
  APPOINTMENT: PermContactCalendarRoundedIcon,
  EDITOR: BorderColorRoundedIcon,
  MASSIVE_SENDING: SmsIcon,
  SENDS_ANALYSIS: BarChartRoundedIcon,
  PRACTICES: InsertDriveFileIcon,
  USER_MANAGEMENT: ManageAccountsIcon,
  SPOT: TrackChangesRoundedIcon,
  WELCOME: WavingHandRoundedIcon,
  WAVE_MANAGEMENT: ManageHistoryRoundedIcon,
  WAVE: EventRepeatRoundedIcon,
  CAMPAIGNS_MANAGEMENT: CampaignRoundedIcon,
  CONFIGURATIONS: SettingsRoundedIcon,
  ROLES_MANAGEMENT: AttributionRoundedIcon,
  BRANCHES_MANAGEMENT: FactoryRoundedIcon,
  CUSTOMERS_CAMPAIGNS_MANAGEMENT: CampaignRoundedIcon,
  ACTIVITYPROGRESS_MANAGEMENT: StairsRoundedIcon,
  PERMISSIONS_MANAGEMENT: AdminPanelSettingsRoundedIcon,
  ROUTES_MANAGEMENT: AltRouteRoundedIcon,
};

/**
 * Icons addressable by name, for anything whose icon is chosen by data rather than by code: a
 * declared vocabulary, a descriptor, a saved layout.
 *
 * Keys are the MUI export name, so a name in the data says exactly which icon it means. Making a new
 * icon available is one import and one entry here; using one that is already listed is a data
 * change.
 */
export const ICON_BY_NAME = {
  AccountBalance: AccountBalanceIcon,
  Cake: CakeIcon,
  Call: CallRoundedIcon,
  Campaign: CampaignRoundedIcon,
  ChairOutlined: ChairOutlinedIcon,
  Circle: CircleIcon,
  Close: CloseIcon,
  CottageOutlined: CottageOutlinedIcon,
  Done: DoneIcon,
  FiberManualRecord: FiberManualRecordIcon,
  Percent: PercentIcon,
  PriceCheckRounded: PriceCheckRoundedIcon,
  RealEstateAgentRounded: RealEstateAgentRoundedIcon,
  SavingsRounded: SavingsRoundedIcon,
  DirectionsCarFilledRounded: DirectionsCarFilledRoundedIcon,
  EmojiEvents: EmojiEventsRoundedIcon,
  FilterAltOff: FilterAltOffRoundedIcon,
  InsertDriveFile: InsertDriveFileIcon,
  LocalHospitalOutlined: LocalHospitalOutlinedIcon,
  PersonOffRounded: PersonOffRoundedIcon,
  PhoneDisabled: PhoneDisabledRoundedIcon,
  PlaylistAddCheckOutlined: PlaylistAddCheckOutlinedIcon,
  Sms: SmsIcon,
  Star: StarIcon,
  TrackChanges: TrackChangesRoundedIcon,
  WavingHand: WavingHandRoundedIcon,
  Widgets: WidgetsRoundedIcon,
};

/** The fallback for a name that is not listed. */
export const DEFAULT_ICON_NAME = 'Widgets';

/**
 * The icon component a name refers to, falling back to the default rather than rendering nothing.
 *
 * @param {String} name - A key of ICON_BY_NAME.
 *
 * @returns {React.ElementType}
 */
export const resolveIcon = (name) =>
  ICON_BY_NAME[name] ?? ICON_BY_NAME[DEFAULT_ICON_NAME];
